import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Shell = () => import('@/views/index.vue')

const routes = [
  {
    path: '/',
    component: Shell,
    children: [
      { path: '', name: 'home', component: () => import('@/views/home/home.vue') },
      { path: 'about', name: 'about', component: () => import('@/views/about/index.vue') },
      { path: 'servicios', name: 'services', component: () => import('@/views/services/index.vue') },
      { path: 'blog', name: 'blog', component: () => import('@/views/blog/index.vue') },
      { path: 'portafolio', name: 'portafolio', component: () => import('@/views/portafolio/index.vue') },
      { path: 'digital', name: 'digital', component: () => import('@/views/digital/index.vue') },
      { path: 'planning', name: 'planning', component: () => import('@/views/planning/index.vue') },
      { path: 'uxui', name: 'uxui', component: () => import('@/views/uxui/index.vue') },
      { path: 'contacto', name: 'contacto', component: () => import('@/views/contact/index.vue') },
      { path: 'development', name: 'development', component: () => import('@/views/development/index.vue') },
      { path: 'staff-augmentation-services', name: 'staff-augmentation-services', component: () => import('@/views/staff-augmentation-services/index.vue') },
      { path: 'mobile-development', name: 'mobile-development', component: () => import('@/views/mobile-development/index.vue') },
      { path: 'privacy-policy', name: 'privacy-policy', component: () => import('@/views/privacy-policy/index.vue') },
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, behavior: 'smooth', offset: { x: 0, y: 80 } }
    return { x: 0, y: 0 }
  }
})

export default router